import Spec from "./Spec"
import { buildFunction } from "./SpecFunctionServices"
import { SpecManager } from "./SpecManager"

export default class SpecTernaryOperator extends Spec {
    conditionF: Function

    aF: Function
    bF: Function

    toUpdate: boolean = false

    conditionValue: boolean = null
    aValue_: string | number | boolean = null
    bValue_: string | number | boolean = null
    userValue: string | number | boolean = null

    aIsUserValue:boolean = false
    bIsUserValue:boolean = false

    aDependencies: { [k: string]: Spec } = {};
    bDependencies: { [k: string]: Spec } = {};

    private globalReadonly: boolean = true;
    globalUserValue: string | number | boolean = null

    get readonly(): boolean {
        if (this.specManager.readonly) {
            return true;
        }
        if (!this.globalReadonly) {
            return false
        }
        return this._readonly
    }

    set readonly(value: boolean) {
        this.globalReadonly = value;
    }

    get aValue() {
        if (this.aIsUserValue) return this.userValue
        return this.aValue_
    }

    get bValue( ) {
        if (this.bIsUserValue) return this.userValue
        return this.bValue_
    }

    get originalValue() {
        return this.conditionValue ? this.aValue : this.bValue
    }

    get value() {
        if (this.globalUserValue !== null && this.globalUserValue !== undefined) {
            return this.globalUserValue
        }
        return this.originalValue
    }

    set value(value: string | number | boolean) {
        if (!this.globalReadonly) {
            this.globalUserValue = value
        } else {
            this.userValue = value
        }
        this.onModified()
    }

    get toBeIncludedInTheBundle(): boolean {
        return !!this.userValue
    }

    constructor(
        key: string,
        private condition: string,
        private a: string,
        private b: string,
        specManager: SpecManager,
        readonly: boolean
    ) {
        // if (key.startsWith("CONSISTENCY:"))
        // debugger
        super(specManager, key, readonly)
        this.initializeFunctions()
        this.toUpdate = true
    }

    setDependencies(dependencies: Spec[], key = null) {
        const cds = Spec.getDependencies(this.condition)
        const ads = Spec.getDependencies(this.a)
        const bds = Spec.getDependencies(this.b)
        for (const dependency of dependencies) {
            // const internalKey = key || dependency.key
            const internalKey = this.getDependencyKey(dependency,  key)
            if (!internalKey) {
                debugger
                continue
            }
            if (cds.indexOf(internalKey) !==-1) {
                this.dependencies[internalKey] = dependency;
            }
            if (ads.indexOf(internalKey) !==-1) {
                this.aDependencies[internalKey] = dependency;
            }
            if (bds.indexOf(internalKey) !==-1) {
                this.bDependencies[internalKey] = dependency;
            }
            this.toUpdate = true
            dependency.addImpacted(this);
        }
        this.initializeFunctions()
    }

    initializeFunctions() {
        if (this.condition.length) {
            const buildCondition = buildFunction(this, this.condition)
            this.conditionF = () => {
                // if (this.key === 'KD') {
                //     debugger
                // }
                try {
                    this.conditionValue = eval(buildCondition)
                    return this.conditionValue
                } catch (e) {
                    console.log({
                        error: "Compute function error condition",
                        key: this.key,
                        func: buildCondition,
                        e
                    })
                    return false
                }
                // let value = eval(newF)
                // return value
            }
        } else {
            debugger
        }
        if (this.a.length) {
            if (this.a.indexOf("USER_VALUE") !== -1 ) {
                this.aIsUserValue = true
            } else {
                this.aIsUserValue = false
                const buildA = buildFunction(this, this.a, "aDependencies")
                this.aF = () => {
                    // if (this.key === 'KD') {
                    //     debugger
                    // }
                    try {
                        this.aValue_ = eval(buildA)
                        return this.aValue_
                    } catch (e) {
                        debugger
                        console.log({
                            error: "Compute function error a",
                            key: this.key,
                            func: buildA,
                            e
                        })
                        return 0
                    }
                    // let value = eval(newF)
                    // return value
                }
            }
        } else {
            console.error("ternary operator with a undefined uniqueKey= ", this.uniqueKey)
            debugger
        }
        if (this.b.length) {
            if (this.b.indexOf("USER_VALUE") !== -1 ) {
                this.bIsUserValue = true
            } else {
                this.bIsUserValue = false
                const buildB = buildFunction(this, this.b, "bDependencies")
                this.bF = () => {
                    try {
                        this.bValue_ = eval(buildB)
                        return this.bValue_
                    } catch (e) {
                        debugger
                        console.log({
                            error: "Compute function error b",
                            key: this.key,
                            func: buildB,
                            e
                        })
                        return 0
                    }
                }
            }
        } else {
            console.error("ternary operator with b undefined uniqueKey= ", this.uniqueKey)
            debugger
        }
    }

    update(used) {
        if (this.toUpdate) {
            if (used.length && used.indexOf(this.uniqueKey) !==-1) {
                // debugge
                // console.error(used.indexOf(logKey))
                console.error("already updated=", used.join(","))
                return
            }
            used.push(this.uniqueKey)
            // console.log(logKey)
            // debugger
            for (const key in this.dependencies) {
                const dependency = this.dependencies[key]
                dependency.update(used);
            }
            // for (const imp of this.impacted) {
            //     imp.update(used);
            // }
            this.conditionF()
            if (this.conditionValue) {
                if (this.aF) {
                    this._readonly = true
                    for (const key in this.aDependencies) {
                        const dependency = this.aDependencies[key]
                        dependency.update(used);
                    }
                    this.aF()
                } else if (this.aIsUserValue) {
                    this._readonly = false
                }
            } else {
                if (this.bF) {
                    this._readonly = true
                    for (const key in this.bDependencies) {
                        const dependency = this.bDependencies[key]
                        dependency.update(used);
                    }
                    this.bF()
                } else if (this.bIsUserValue) {
                    this._readonly = false
                }
            }
            this.toUpdate = false;
        }
    }

    build() {
        // if (this.specManager.readonly) {
        //     return
        // }
        // try {
        //     this.conditionF()
        //     if (this.conditionValue) {
        //         if (this.aF) {
        //             this.readonly = true
        //             this.aF()
        //         } else if (this.aIsUserValue) {
        //             this.readonly = false
        //         }
        //     } else {
        //         if (this.bF) {
        //             this.readonly = true
        //             this.bF()
        //         } else if (this.bIsUserValue) {
        //             this.readonly = false
        //         }
        //     }
        // } catch (error) {
        //     debugger
        // }
    }

    getValue(): string | number | boolean {
        return this.value
    }

    setStream(stream: { userValue: string | number | boolean,
                        conditionValue: boolean,
                        aValue_: string | number| boolean,
                        bValue_: string | number| boolean,
                        aIsUserValue: boolean, bIsUserValue: boolean,
                        readonly: boolean,
                        globalReadonly: boolean,
                        globalUserValue: string | number| boolean,}) {
        this.userValue = stream.userValue
        this.conditionValue = stream.conditionValue
        this.aValue_ = stream.aValue_
        this.bValue_ = stream.bValue_
        this.aIsUserValue = stream.aIsUserValue
        this.bIsUserValue = stream.bIsUserValue
        this._readonly = stream.readonly
        this.globalReadonly = stream.globalReadonly === undefined ? true : stream.globalReadonly
        this.globalUserValue = stream.globalUserValue === undefined ? null : stream.globalUserValue
    }

    getStreamValue() {
        return {
            userValue: this.userValue,
            conditionValue: this.conditionValue,
            aValue_: this.aValue_,
            bValue_: this.bValue_,
            aIsUserValue: this.aIsUserValue,
            bIsUserValue: this.bIsUserValue,
            readonly: this._readonly,
            globalReadonly: this.globalReadonly,
            globalUserValue: this.globalUserValue
        }
    }

    resetOriginalValue() {
        this.globalUserValue = null
    }

    get isUserValue():boolean {
        if (this.globalUserValue !== null) {
            return true
        }
        return this.conditionValue ? this.aIsUserValue : this.bIsUserValue
    }
}